// data/languages/wolof/illustrations.ts

export const categoryIllustrations = {
    'Salutations et expressions courantes': '👋',
    'Nombres': '🔢',
    'Temps': '📅',
    'Animaux': '🐘',
    'Famille': '👨‍👩‍👧‍👦',
    'Nourriture': '🍽️',
    'Couleurs': '🎨',
    'Corps': '🧑',
    'Objets du quotidien' : ' 🧰',
    'Verbes': '🏃‍♂️',
   
  };

  export default categoryIllustrations ; 